import { TFunction } from "i18next"
import { EMPTY_VALUE_PLACEHOLDER } from "@/modules/admin/better-doc/constants/better-doc-constants"
import { de_BetterDocRecommendationState } from "@/types/__generated__/union-types"

export type BetterDocEnumLabelGroup =
  | "exchangeOperation"
  | "exchangeOutcome"
  | "insuranceCountry"
  | "navigationType"
  | "recommendationState"
  | "recommendationType"
  | "remoteRequestStatus"
  | "sessionStepType"
  | "testCaseOutcome"
  | "testCaseScenario"

export const getBetterDocEnumLabel = (t: TFunction, labelGroup: BetterDocEnumLabelGroup, value: string) =>
  t(`admin.betterDoc.${labelGroup}.${value}`, { defaultValue: t("admin.betterDoc.unknownValue") })

export const formatBetterDocRecommendationState = (t: TFunction, state: de_BetterDocRecommendationState | null) =>
  state === null ? EMPTY_VALUE_PLACEHOLDER : getBetterDocEnumLabel(t, "recommendationState", state)
